import './jquery-global';

$(function () {

  let umantisJobLink = $(".js-applyJobLink").attr("href");
  if (umantisJobLink) {
    let applyJobsHeaderLink = $(".js-applyJobsHeaderLink");
    if (applyJobsHeaderLink) {
      applyJobsHeaderLink.attr('href', umantisJobLink);
    }
  }

  const whatsAppLink = $(".js-applyWhatsappLink").attr("href");
  if (whatsAppLink) {
    let applyWhatsappLink = $(".js-applyWhatsappHeaderLink");
    if (applyWhatsappLink) {
      document.body.classList.add('career--whatsapp');
      applyWhatsappLink.attr('href', whatsAppLink);
      applyWhatsappLink.show();
    }
  }
});
